// extracted by mini-css-extract-plugin
export default {"textarea":"textarea_textarea__ra8hw","error":"textarea_error__g59R+"};